
// ** Initial State
export const initialState = {
  operators: []
}

const operatorReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_OPERATORS':
      return { ...state, operators: action.data }
    default:
      return state
  }
}

export default operatorReducer